// import DesignIllustration from "../../../images/design-illustration.svg";
// import Img from "gatsby-image";
import React from 'react'
import { ReactComponent as SvgDecoratorBlob1 } from '../../../images/svg-decorator-blob-1.svg'
import { ReactComponent as SvgDecoratorBlob2 } from '../../../images/dot-pattern.svg'
//eslint-disable-next-line
// import { css } from "styled-components/macro";
import styled from 'styled-components'
import tw from 'twin.macro'
import BackgroundImage from 'gatsby-background-image'

const Container = tw.div`relative`
const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center container mx-auto p-6 lg:py-24`
const LeftColumn = tw.div`relative lg:w-6/12 lg:pr-12 flex-shrink-0 text-center lg:text-left`
const RightColumn = tw.div`relative mt-12 lg:mt-0 flex flex-col justify-center`

const Heading = styled.h1(({ isDark }) => [
  tw`font-extrabold leading-snug max-w-3xl text-4xl sm:text-5xl md:text-6xl`,
  // Ternary
  isDark ? tw`text-gray-100` : tw`text-black`,
])

const Paragraph = styled.p(({ isDark }) => [
  tw`px-4 md:px-0 my-5 lg:my-8 text-lg sm:text-xl max-w-lg mx-auto lg:mx-0`,
  // Ternary
  isDark ? tw`text-white` : tw`text-black`,
])

const Actions = tw.div`flex flex-col items-center sm:flex-row justify-center lg:justify-start mt-8`
const PrimaryButton = tw.button`font-bold px-8 lg:px-10 py-3 rounded bg-green-500 text-gray-100 hocus:bg-green-700 focus:shadow-outline focus:outline-none transition duration-300`
// const WatchVideoButton = styled.button`
//   ${tw`mt-4 sm:mt-0 sm:ml-8 flex items-center text-blue-300 transition duration-300 hocus:text-green-400 focus:outline-none`}
//   .playIcon {
//     ${tw`stroke-1 w-12 h-12`}
//   }
//   .playText {
//     ${tw`ml-2 font-medium`}
//   }
// `;

const IllustrationContainer = tw.div`flex justify-center md:justify-end items-center relative max-w-3xl lg:max-w-none z-10`

// Random Decorator Blobs (shapes that you see in background)
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none opacity-25 absolute hidden lg:block left-0 bottom-0 h-1/2 w-1/2 transform -translate-x-1/3 `}
`
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none fill-current text-green-500 opacity-25 absolute w-32 h-32 right-0 bottom-0 transform translate-x-10 translate-y-10 z-0`}
`

export const Hero = ({
  heading = 'Modern React Templates, Just For You',
  description = 'Our templates are easy to setup, understand and customize. Fully modular components with a variety of pages and components.',
  greenButtonText = null,
  greenButtonUrl = '#',
  // watchVideoButtonText = "Watch Video",
  imageSrc,
  // imageCss = null,
  isDark,
  imageDecoratorBlob = true,
}) => {
  return (
    <BackgroundImage
      Tag="section"
      fluid={imageSrc}
      style={{ backgroundPosition: 'top right' }}
    >
      <Container>
        <div
          className={`absolute inset-0 w-full h-full bg-black bg-opacity-50`}
        />
        <TwoColumn>
          <LeftColumn>
            <Heading isDark={isDark}>{heading}</Heading>
            <Paragraph isDark={isDark}>{description}</Paragraph>
            <Actions>
              {greenButtonText && (
                <PrimaryButton as="a" href={greenButtonUrl}>
                  {greenButtonText}
                </PrimaryButton>
              )}

              {/*            <WatchVideoButton onClick={toggleModal}>*/}
              {/*<span className="playIconContainer">*/}
              {/*    <div className="playIcon">play</div>*/}
              {/*</span>*/}
              {/*                <span className="playText">{watchVideoButtonText}</span>*/}
              {/*            </WatchVideoButton>*/}
            </Actions>
          </LeftColumn>
          <RightColumn>
            <IllustrationContainer>
              {imageDecoratorBlob && <DecoratorBlob2 />}
              {/*{imageDecoratorBlob && (<div><img src={SvgDecoratorBlob2}*/}
              {/*                                  className={'pointer-events-none ' +*/}
              {/*                                  'fill-current text-green-500 opacity-25 absolute w-32 h-32 right-0 ' +*/}
              {/*                                  'bottom-0 transform translate-x-10' +*/}
              {/*                                  ' translate-y-10 z-0'}/>*/}
              {/*    </div>*/}
              {/*)*/}
              {/*}*/}
            </IllustrationContainer>
          </RightColumn>
        </TwoColumn>
        {imageDecoratorBlob && <DecoratorBlob1 />}
      </Container>
    </BackgroundImage>
  )
}
